export default __webpack_public_path__ + "static/media/Icons_Tick icon.8cebfe43.svg";